import React, {useEffect, useState} from 'react';
import {SFuncModal, STitle} from 'shj-components';
import {MinusCircleOutlined, PlusOutlined} from '@ant-design/icons';
import {Button, Flex, Form, Input, InputNumber, message, Select, Skeleton, Space,} from 'antd';
import {useRequest, useSetState} from "ahooks";
import { findConfigById, saveConfig} from "@/services/qualityMoneyAccount.ts";
import { authDict } from 'shj-utils';
import { getWorkTypeList } from '@/services';

const {Option} = Select;

export function addOrEditFn({fn, ...rest}) {
    const onClose = () => {
        dialog.destroy();
    };
    const dialog = SFuncModal({
        title: `${rest?.id ? '编辑' : '新增'}`,
        width: 700,
        vanish: true,
        content: <ModalAddOrEditDom onClose={onClose} fn={fn} {...rest}/>,
    });

    return dialog;
}

const ModalAddOrEditDom = ({onClose, fn, ...rest}) => {
    const [form] = Form.useForm();
    const [companyList, setCompanyList] = useState<any>([]);
    const [workTypeList, setWorkTypeList] = useState<any>([]);
    const [amountList, setAmountList] = useState([
        {
            minAmount: 0,
        },
    ]);
    let [state, setState] = useSetState({totalPaymentAmount: 0});
    const {setFieldsValue} = form;
    const record = rest?.record

    let {loading: saveLoading, runAsync: runAsyncSave} = useRequest(saveConfig, {manual: true});
    let {loading: getLoading, runAsync: runAsyncSearch} = useRequest(findConfigById, {manual: true});

    useEffect(() => {
        const {companyList} = rest;
        getWorkTypeList(true).then(res => {
            setWorkTypeList(res);
        })
        setCompanyList(companyList);
        if (rest?.id) {
            getDetail(rest?.id);
            setFieldsValue({...record})
        } else {
            setFieldsValue({
                configDetails: amountList,
            });
        }
        return () => {
        };
    }, [rest?.id]);

    //根据ID获取详情
    const getDetail = (id) => {
        runAsyncSearch(id).then((data) => {
            setState({totalPaymentAmount: data?.totalPaymentAmount})
            setFieldsValue({
                ...data,
                configDetails: (data?.configDetails || []).sort((p, l) => p.minAmount - l.minAmount)
            })
        })
    };


    // 提交
    const onFinish = () => {
        form.validateFields().then((values: any) => {
            let configDetails = values.configDetails;
            for (let item of configDetails) {
                let index = configDetails.indexOf(item);
                if (index - 1 > -1) {
                    item.minAmount = configDetails[index - 1].maxAmount;
                }
            }
            if (values.configDetails.length === 0) {
                message.warning('请添加扣费区间', 3);
                return;
            }

            for (let item of configDetails) {
                if (item?.maxAmount <= item?.minAmount) {
                    message.warning('最大金额不能小于等于最小金额', 3);
                    return;
                }
                if (!item?.proportion) {
                    message.warning('比例不能为0', 3);
                    return;
                }
            }

            if (configDetails[configDetails?.length - 1].maxAmount !== values?.totalPaymentAmount) {
                message.warning('最后区间的最大值需要等于总缴纳金', 3);
                return;
            }
            runAsyncSave({data: {...record, ...values}}).then((res) => {
                message.success(res?.message);
                onClose();
                fn && fn();
            })
        })

    };
    const onChange = (value) => {
        if (value[value.length - 1] === '0') {
            form.setFieldsValue({
                ['companyIds']: ['0'],
            })
        } else {
            value = value.filter(item => item !== '0')
            form.setFieldsValue({
                ['companyIds']: value,
            })
        }
    }
    const closeModal = () => {
        onClose();
    };

    // const maxAmountChange = (data) => {
    // console.log(data);
    // };

    const iiDisabled = (key) => {
        !authDict[key]
    };

    const onValuesChange = (value) => {
        if (value.totalPaymentAmount != null) {
            setState({totalPaymentAmount: value.totalPaymentAmount})
        }
        if (value.configDetails != null) {
            form.setFieldValue(['configDetails', 0, 'minAmount'], 0);
        }
    }

    const reqMeg = '不能为空';
    const formItemLayout = {
        labelCol: {span: 5},
        wrapperCol: {span: 24},
    };

    return (
        <div>
            {getLoading ? (
                <Skeleton active/>
            ) : (
                <SFuncModal.Content
                    onCancel={closeModal}
                    onOk={onFinish}
                    confirmLoading={saveLoading}>
                    <Form form={form} onValuesChange={onValuesChange} layout="vertical">
                        <Form.Item style={{display: 'none'}} name="id">
                            <Input/>
                        </Form.Item>
                        <Form.Item
                            label="门店"
                            name="companyIds"
                            rules={[{required: true, message: reqMeg}]}
                            {...formItemLayout}
                        >
                            <Select
                                mode="multiple"
                                showSearch
                                allowClear={true}
                                filterOption={(input: any, option: any) => {
                                    return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                }}
                                onChange={(value: any) => onChange(value)}
                                optionFilterProp="children"
                            >
                                <Option key={-1} value={'0'}>通用</Option>
                                {companyList &&
                                    companyList.map((item, index) => (
                                        <Option key={index} value={item.orgId}>
                                            {item.companyName}
                                        </Option>
                                    ))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="技能标签"
                            name="workTypeIds"
                            rules={[{required: true, message: reqMeg}]}
                            {...formItemLayout}
                        >
                            <Select
                                mode="multiple"
                                showSearch
                                allowClear={true}
                                filterOption={(input: any, option: any) => {
                                    return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                }}
                                optionFilterProp="children"
                            >
                                {workTypeList &&
                                    workTypeList.map((item, index) => (
                                        <Option key={index} value={item.id}>
                                            {item.name}
                                        </Option>
                                    ))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="入职缴纳金额(¥)"
                            name="entryPaymentAmount"
                            {...formItemLayout}
                            rules={[{required: true, message: reqMeg}]}
                        >
                            <InputNumber
                                precision={2}
                                min={1}
                                max={1000000}
                                style={{width: '100%'}}
                            />
                        </Form.Item>
                        <Form.Item
                            label="总缴纳金额(¥)"
                            name="totalPaymentAmount"
                            {...formItemLayout}
                            rules={[{required: true, message: reqMeg}]}
                        >
                            <InputNumber
                                precision={2}
                                min={1}
                                max={1000000}
                                style={{width: '100%'}}
                            />
                        </Form.Item>
                        <STitle titleMode="edit" title={`扣费阶梯【0.00—${state.totalPaymentAmount}】`} style={{marginBottom: '10px'}}/>
                        <Form.List name="configDetails" {...formItemLayout} >
                            {(fields, {add, remove}) => (
                                <>
                                    {fields.map(({key, name, ...restField}) => (
                                        <Space key={key} style={{display: 'flex', marginBottom: 8}}
                                               align="baseline">
                                            <Form.Item
                                                noStyle
                                                shouldUpdate
                                            >
                                                {({getFieldValue}) => {
                                                    let data = getFieldValue('configDetails');
                                                    return (
                                                        <Flex align='center'>
                                                            <Form.Item
                                                                layout="horizontal"
                                                                {...restField}
                                                                label={'区间' + (name + 1)}
                                                                name={[name, 'minAmount']}
                                                            >
                                                                <InputNumber disabled={true} style={{width: '100px'}}/>
                                                            </Form.Item>
                                                            <Form.Item>
                                                                <div style={{margin: '10px'}}>-</div>
                                                            </Form.Item>
                                                            <Form.Item
                                                                {...restField}
                                                                name={[name, 'maxAmount']}
                                                                style={{marginRight: '20px'}}
                                                                validateTrigger={['onBlur', 'onChange']}
                                                                rules={[
                                                                    {required: true, message: reqMeg},
                                                                    {
                                                                        validator: (_, value) => {
                                                                            try {
                                                                                if (value > form.getFieldValue('totalPaymentAmount')) {
                                                                                    return Promise.reject(new Error('必须等于总缴纳金额'));
                                                                                } else {
                                                                                    return Promise.resolve();
                                                                                }
                                                                            } catch (err) {
                                                                                return Promise.reject();
                                                                            }
                                                                        },
                                                                        message: '必须等于总缴纳金额',
                                                                    },
                                                                ]}
                                                            >
                                                                <InputNumber
                                                                    style={{width: '180px'}}
                                                                    min={data[name]?.minAmount + 1}
                                                                    max={state.totalPaymentAmount}
                                                                    onChange={value => {
                                                                        let length = form.getFieldValue('configDetails').length || 0;
                                                                        if (length > (name + 1)) {
                                                                            form.setFieldValue(['configDetails', name + 1, 'minAmount'], value);
                                                                        }
                                                                    }}
                                                                />
                                                            </Form.Item>

                                                            <Form.Item
                                                            layout="horizontal"
                                                                {...restField}
                                                                label="扣款比例"
                                                                name={[name, 'proportion']}
                                                                rules={[{required: true, message: reqMeg}]}
                                                            >
                                                                <InputNumber
                                                                    style={{width: '180px'}}
                                                                    min={0}
                                                                    max={100}
                                                                />
                                                            </Form.Item>
                                                            {
                                                                data.length-1 === name && !iiDisabled('MoneyChangeAddRate') && data.length >1 ? (
                                                                    <Form.Item>
                                                                        <MinusCircleOutlined style={{marginLeft: '5px'}}
                                                                                             onClick={() => {
                                                                                                 remove(name);
                                                                                             }}
                                                                        />
                                                                    </Form.Item>
                                                                ) : null
                                                            }
                                                        </Flex>
                                                    );
                                                }}
                                            </Form.Item>
                                        </Space>
                                    ))}
                                    <Form.Item {...formItemLayout}>
                                        <Button
                                            type="dashed"
                                            onClick={() => {
                                                let data = form.getFieldValue('configDetails');
                                                if(data[data?.length - 1].maxAmount === form.getFieldValue('totalPaymentAmount')) {
                                                    message.warning('最后一个区间和总缴纳金额相同不能添加新区间', 3);
                                                    return
                                                }
                                                add({minAmount: data[data.length - 1]?.maxAmount});
                                            }}
                                            block
                                            icon={<PlusOutlined/>}
                                        >
                                            添加
                                        </Button>
                                    </Form.Item>
                                </>
                            )}
                        </Form.List>
                    </Form>
                </SFuncModal.Content>
            )}
        </div>
    );
};
